import { text } from '@modules/auth/text';

export function getGuestErrorMessage(error: Error): string {
  return error.message || text.guestError;
}
